import {
    SET_TRIP_TYPE_VALUE,
    SET_COVER_FOR_VALUE,
    SET_DEPARTURE_COUNRTY_VALUE,
    SET_DESTINATION_COUNRTY_VALUE,
    SET_DEPARTURE_DATE_VALUE,
    SET_RETURN_DATE_VALUE,
    SET_NO_OF_TRAVELLERS_VALUE,
    SET_FULL_NAME_VALUE,
    EMAIL_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    SET_NO_OF_MINORS_VALUE,
    SET_AGE_VALUE,
    setFullNameValid,
    setTripTypeValid,
    setCoverForValid,
    setDepartureCountryValid,
    setDestinationCountryValid,
    setDepatureDateValid,
    setReturnDateValid,
    setNoOfTravellersValid,
    setAgeValid,
    setNoOfMinorsValid,
    setEmailValid,
    setPhoneNumberValid,
    setIdNumberValid,
} from '../../../actions/travelSs/quote';
import { getDepatureDate, getReturnDate, getSelectedCover, getTripType } from '../../../selectors/travelSs/quote';
import {
    validateSelection,
    validateNumber,
    validateDate,
    validateName,
    validateEmail,
    validateContactNumber,
} from '@om/validation';
import { validationIsEqual } from '../status';
import { validateUgandanId } from '@om/validation/src/validators/ugandan-id-validator';

let prevValidationAction = null;

export const quoteFormValidation = (store, next, action) => {
    const state = store.getState();

    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    const depatureDate = getDepatureDate(state);
    const selectedCover = getSelectedCover(state);
    const returnDate = getReturnDate(state);

    const tripDays = getTripType(state);
    const minDays = tripDays.value?.split('-')[0]
    const maxDays = tripDays.value?.split('-')[1]

    function convertDateFormat(dateStr) {
        // Split the date string by '/'
        console.log(dateStr, 'JHKJHKJ')
        const parts = dateStr?.split('/');
        
        // Ensure the input has the correct format
        if (parts?.length !== 3) {
            return "Invalid date format. Use DD/MM/YYYY.";
        }
    
        const [day, month, year] = parts;
    
        // Ensure the date values are valid
        if (isNaN(day) || isNaN(month) || isNaN(year)) {
            return "Invalid date values.";
        }
    
        // Format it as YYYY-MM-DD
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    function isValidReturnDate(returnDate, minDays, maxDays, startDate = new Date()) {
        // Convert input dates to Date objects
        const returnDateObj = new Date(returnDate);
        const startDateObj = new Date(startDate);
        
        // Ensure returnDate is a valid date
        if (isNaN(returnDateObj)) {
            return "Invalid return date.";
        }
    
        // Calculate the minimum and maximum allowed return dates
        const minAllowedDate = new Date(startDateObj);
        minAllowedDate.setDate(minAllowedDate.getDate() + minDays);
    
        const maxAllowedDate = new Date(startDateObj);
        maxAllowedDate.setDate(maxAllowedDate.getDate() + maxDays);
    
        // Validate the return date
        if (returnDateObj < minAllowedDate) {
            return `Return date must be at least ${minDays} days from ${startDate}.`;
        }
    
        if (returnDateObj > maxAllowedDate) {
            return `Return date must not exceed ${maxDays} days from ${startDate}.`;
        }
    
        return null; // Valid return date
    }

    // Example usage:

    let minAge = 0;
    let maxAge = 75;

    if (selectedCover.value === 'Student') {
        maxAge = 30;
    }

    if (selectedCover.value === 'Senior') {
        minAge = 76;
        maxAge = 85;
    }

    function extractMinMaxDays(range) {
        if (!range.includes('days')) {
            return null;
        }

        const match = range.match(/(\d+)-(\d+)/);

        if (!match) {
            return null;
        }

        const minDays = parseInt(match[1], 10);
        const maxDays = parseInt(match[2], 10);

        return { minDays, maxDays };
    }

    function validateDestinationDate(departureDate, destinationDate) {
        const tripType = getTripType(state);

        const daysObj = extractMinMaxDays(tripType.value);

        if (daysObj !== null) {
            const { minDays, maxDays } = daysObj;

            // Parse the dates
            const [day1, month1, year1] = departureDate.split('/').map(Number);
            const [day2, month2, year2] = destinationDate.split('/').map(Number);

            const departure = new Date(year1, month1 - 1, day1);
            const destination = new Date(year2, month2 - 1, day2);

            // Check if departure date is greater than destination date
            if (departure > destination) {
                return 'Departure date cannot be later than the destination date.';
            }

            // Check if destination date is more than n days from departure date
            const maxDate = new Date(departure);
            maxDate.setDate(maxDate.getDate() + maxDays);

            if (destination > maxDate) {
                return `Return date must be between ${minDays} and ${maxDays} days from the selected departure date.`;
            }
        }

        return null;
    }

    function validatePassport(passport) {
        const passportRegex = /^[A-Z0-9]{8,20}$/;
        return passportRegex.test(passport);
    }

    const validationAction = (() => {
        let error;
        let today = new Date();
        let validTodayDate = today.toLocaleDateString('en-NG').split('/').join('/');
        switch (action.type) {
            case SET_FULL_NAME_VALUE:
                error = validateName(action.value, {
                    min: 5,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateUgandanId(action.value);

                if (error !== null) {
                    const passportIsValid = validatePassport(action.value);
                    error = passportIsValid ? null : 'Enter valid national id/passport number';
                }

                return setIdNumberValid(error);

            case SET_TRIP_TYPE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Trip type value' });
                return setTripTypeValid(error);

            case SET_COVER_FOR_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Cover for value' });
                return setCoverForValid(error);

            case SET_AGE_VALUE:
                error = validateNumber(action.value, { min: minAge, max: maxAge, subject: 'Age' });

                if (error === 'Oops, you need to enter an age greater than 76.') {
                    error = 'Oops, you need to enter an age greater than 75.';
                }

                if (error === 'Oops, you need to enter an age less than 85.') {
                    error = 'Oops, you need to enter an age less than 86.';
                }

                return setAgeValid(error);
            case SET_DEPARTURE_COUNRTY_VALUE:
                error = validateName(action.value, { min: 1, subject: 'Departure country' });
                return setDepartureCountryValid(error);

            case SET_DESTINATION_COUNRTY_VALUE:
                error = validateName(action.value, { min: 1, subject: 'Destination country' });
                return setDestinationCountryValid(error);

            case SET_DEPARTURE_DATE_VALUE:
                error = validateDate(action.value, { min: validTodayDate, subject: 'Departure date' });
                return setDepatureDateValid(error);

            case SET_RETURN_DATE_VALUE:
                error = isValidReturnDate(convertDateFormat(returnDate.value), parseInt(minDays), parseInt(maxDays), convertDateFormat(depatureDate.value));

                return setReturnDateValid(error);

            case SET_NO_OF_TRAVELLERS_VALUE:
                error = validateNumber(action.value, { min: 0, subject: 'Number of adults' });
                return setNoOfTravellersValid(error);

            case SET_NO_OF_MINORS_VALUE:
                error = validateNumber(action.value, { min: 0, subject: 'Number of minors' });
                return setNoOfMinorsValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
